import { gqlClient } from '@/utilities/graphQLClient';
import { gql } from '@/utilities/gql';

import type { QueryFunctionContext } from '@tanstack/react-query';

export const queryFn = async ({
  queryKey: [_keyof, id, size],
}: QueryFunctionContext<[string, string, number | undefined]>) => {
  const response = await gqlClient.request(
    gql(`
      query getCompanyPriceTargetHistory($id: String!, $size: Int) {
        Company(id: $id) {
          priceTargetHistory(size: $size) {
            fromDate
            toDate
            consensusMean
            currencyISO
          }
        }
      }
    `),
    { id, size }
  );

  if ('Company' in response) {
    return response.Company;
  }
};
